import React from 'react';
import { observer } from 'mobx-react';

import { UiNavLink } from 'shared/uikit';

import { VmNotificationContentPropsType } from '../../types/VmNotificationContentPropsType';

type PropsType = VmNotificationContentPropsType;

export const VmNotificationComment = observer(({ notification, onClose }: PropsType) => {
    return (
        <div className={'vm-notification__content'}>
            <div className={'vm-notification__name'}>Упоминание в комментариях</div>
            <div className={'vm-notification__description'}>
                {notification.data.comment.user.previewName} упомянула вас в <UiNavLink to={notification.data.comment.url} onClick={onClose}>комментарии</UiNavLink>
            </div>
        </div>
    );
});
